import React from "react"
import { cn } from "@/lib/utils"

interface PageContainerProps {
  children: React.ReactNode
  className?: string
  maxWidth?: string
}

export function PageContainer({ 
  children, 
  className,
  maxWidth = "850px"
}: PageContainerProps) {
  return (
    <div className={cn(
      "flex flex-col items-center p-[24px] lg:p-[48px] bg-[#FFFFFF] min-h-full",
      className
    )}>
      <div 
        className="w-full space-y-[32px]"
        style={{ maxWidth }}
      >
        {children}
      </div>
    </div>
  )
}

